'use strict';

function localized(value) {
  return value;
}
function TODO_localized(s) {
  return s;
}

exports.TODO_localized = TODO_localized;
exports.localized = localized;
//# sourceMappingURL=localized.cjs.map
